const createSearchParams = (loginHash = {}) => {
  const loginData = new URLSearchParams()
  Object.keys(loginHash).map(key => {
    loginData.append(key, loginHash[key])
  })
  return loginData
}

export default createSearchParams
